import BaseApi from './BaseApi'

class AffiliateApi extends BaseApi {
  getLink () {
    return this.post('affiliate/getLink')
  }
}

export default new AffiliateApi()
